export default {
  nome: 'Nome',
  tabela: {
    descricao: 'Descrição',
    descricao_classificacao_pai: 'Descrição da classificação pai',

  },
  titulo_modal: 'Classificação de Instrumento',
};
